<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1500px"
        title="Create Holiday Products"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="addForm" :model="addForm" label-width="110px" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="12">

                        <el-col :span="24">
                            <el-form-item
                                label="Holiday Name"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input Holiday Name',
                                    },
                                ]"
                                prop="name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.name"
                                    placeholder="Please input Holiday Name"
                                ></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="24">
                            <el-form-item
                                label="Date"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please select Date',
                                    },
                                ]"
                                size="small"
                                prop="holiday"
                            >
                                <el-date-picker
                                    v-model="addForm.holiday"
                                    type="date"
                                    placeholder="Please select"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <label for="goods_ids" class="el-form-item__label" :style="{width: $i18n.locale == 'zh' ? '100px' : '110px'}">Products</label>
                            <!-- <el-form-item
                                label="Products"
                                size="small"
                                prop="goods_ids"
                                :label-width="
                                    $i18n.locale == 'zh' ? '100px' : '110px'
                                "
                            > -->
                            <div class="products" :style="{marginLeft: $i18n.locale == 'zh' ? '100px' : '110px'}">
                                <div class="cards-wrap" v-if="products.length > 0">
                                    <div class="card-item" :style="{ marginRight: '10px' }"  v-for="item in products" :key="item.id">
                                            <div class="check-box" @click="deleteProduct(item.id)" title="Remove item">
                                                <!-- <img :src="require('@/assets/image/delete.jpeg')" /> -->
                                                <i class="el-icon-delete"/>
                                            </div> 
                                            <div class="thumb" v-ga="{
                                                eventCategory: 'engagement',
                                                eventAction: 'view_item',
                                            }">
                                                <el-image :lazy="!showDetail" :src="ossImg(item.goods_images && item.goods_images[0], 168, 168)" fit="contain">
                                                    <div slot="error" class="image-slot">
                                                        <i class="el-icon-picture-outline"></i>
                                                    </div>
                                                </el-image>
                                            </div>  
                                            <div class="product-detail">
                                            <p class="title">{{ item.goods_name }}</p>
                                            <p class="subtitle" v-if="roleId != 1">
                                                <span>As low as</span>
                                                <span class="subtitle-price">{{
                                                        item.currency + item.price
                                                }}</span>
                                            </p>
                                        </div>                         
                                    </div>
                                </div>
                            </div>
                            <!-- </el-form-item> -->
                        </el-col>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Find Products"
                            size="small"
                            prop="keyword"
                        >
                            <el-input
                                clearable
                                placeholder="Please input SPU"
                                maxlength="200"
                                size="small"
                                v-model="keyword"
                                @input="getGoodsList"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Category"
                            prop="catalog_id"
                            size="small"
                        >
                            <el-cascader
                                filterable
                                clearable
                                :options="treeData"
                                :props="cascaderProps"
                                v-model="catalog_id"
                                style="width: 100%"
                                placeholder="Plaese Select Category"
                                size="small"
                                :show-all-levels="false"
                                @input="getGoodsList"
                            >
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-scrollbar :style="{ height: 'calc(100% - 68px)' }">
                            <div class="goods-list" ref="goodsListRef">
                                <div class="cards-wrap" v-if="goodsList.length > 0">
                                    <div class="card-item" :style="{ marginRight: '10px'}"
                                        :class="{ 'card-item-select': goods_ids.indexOf(item.id) > -1 ? true : false }" v-for="(item, i) of goodsList"
                                        :key="i">

                                        <div class="thumb" @click="toProducts(item)" v-ga="{
                                            eventCategory: 'engagement',
                                            eventAction: 'view_item',
                                        }">
                                            <el-image :lazy="!showDetail" :src="
                                                ossImg(item.goods_images &&
                                                item.goods_images[0], 168, 168)
                                            " fit="contain">
                                                <div slot="error" class="image-slot">
                                                    <i class="el-icon-picture-outline"></i>
                                                </div>
                                            </el-image>
                                        </div>
                                        <div class="product-detail">
                                            <p class="title">{{ item.goods_name }}</p>
                                            <p class="subtitle" v-if="roleId != 1">
                                                <span>As low as</span>
                                                <span class="subtitle-price">{{
                                                        item.currency + item.price
                                                }}</span>
                                            </p>
                                            <div class="operations">
                                                <el-button type="primary" size="mini" @click="toProducts(item)">Select</el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <el-empty :image-size="200" :style="{ height: 'calc(100% - 45px)' }" v-else></el-empty>
                            </div>
                        </el-scrollbar>
                        <pagination style="text-align: left" :paginationData="paginationData"
                    @paginationChange="paginationChange" :funcName="getGoodsList"></pagination>
                    </el-col>
                </el-row>

            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false">
                Close
            </el-button>
        </span>


    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import tagsInput from "@/common/components/tags-input";
import lwhPopover from "@/common/components/table/lwhPopover.vue";
import inputPopover from "@/common/components/table/inputPopover.vue";
import pagination from "@/common/components/pagination.vue";
import util from "@/utils/util.js";

export default {
    data() {
        return {
            addForm: {
                name: "",
                holiday: "", 
            },
            goods_ids:[],
            products:[],
            goodsList: [],
            paginationData: {
                page: 1,
                "per-page": 9,
                total: "",
            },
            keyword:"",
            catalog_id: "",
            funcName: "getGoodsList",
            loading: false,
            ossImg: util.ossImg
        };
    },
    methods: {

        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .holiday(
                            {
                                ...this.addForm,
                                goods_list: this.goods_ids,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            if (res && res.errcode === 0) {
                                this.$message.success("Success");
                                this.$parent.holiday();
                                this.closeDialog();
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        toProducts(item){
            if(!this.goods_ids.includes(item.id)){
                this.goods_ids.push(item.id);
                this.products.push(item);
            } else {
                this.deleteProduct(item.id)
            }
        },
        deleteProduct(index){
            this.products = this.products.filter(item => item.id !== index);
            this.goods_ids = this.goods_ids.filter(item => item !== index);
        },
        getGoodsList(page, type) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            this.showDetail = false; // 隐藏商品详情页
            // 解决在商品详情页, 搜索其他商品后, 进入详情页,商品信息没改变
            /* this.$router.replace({
                path: "/goodsList",
            }); */
            cmofferApi
                .productList(
                    {
                        ...this.paginationData,
                        menu_id:this.menu_id,
                        keyword: this.keyword,
                        catalog_id: this.catalog_id.toString(),
                        preferred: type == "preferred" ? 1 : 0,
                        promotion: type == "promotion" ? 1 : 0,
                    },
                    "get"
                )
                .then((res) => {
                    this.loading = false;
                    if (res.errcode == 0) {
                        this.goodsList = res.data;
                        this.paginationData.total = res.total;
                        this.loading = false;
                    }
                });
        },
        closeDialog() {
            this.editForm = {
                name: "",
                holiday:"",
            };
            this.goods_ids = [];
            this.products = [];
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },

    },
    components: {
        lwhPopover,
        inputPopover,
        tagsInput,
        pagination,
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
        platform_id: Number,
        treeData: Array,
        goodsTagList: Array,
        cascaderProps: {
            type: () => Object,
            default: {
                value: "id",
                label: "name_en",
                children: "cat_id",
                checkStrictly: true,
                multiple: false,
            },
        },
    },
    computed: {
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
                this.getGoodsList(1);
            }
        },
    },
};
</script>
<style lang="scss">
.add {
    .container {
        width: 100%;
        .el-upload--picture-card {
            float: left !important;
            margin-right: 10px;
        }
        .uploadBox {
            .el-upload,
            .el-upload--text {
                width: 100%;
                height: 100%;
            }
        }
        .describeContent {
            line-height: 1.6;
        }
        .addAttribute {
            color: $color-primary;
            text-align: left;
        }

        .el-checkbox__label {
            font-size: 12px;
        }
        .table {
            .el-form-item {
                margin: 0;
            }
            .el-input-group__prepend {
                padding: 0 10px;
                & + .el-input__inner {
                    padding-right: 10px;
                }
            }
            .lwh_input {
                .el-input__inner {
                    padding: 0 5px 0 10px;
                }
            }
        }
    }
    .el-select--small {
        width: 100%;
    }
    .goods-list {
        overflow-y: auto;

        .cards-wrap {
            display: flex;
            flex-wrap: wrap;
            margin: 0 0 0 20px;

            .card-item {
                position: relative;
                width: 200px;
                min-height: 250px;
                border-radius: 4px;
                border: 1px solid #ededed;
                margin: 0 25px 40px 20px;
                padding: 10px 15px 20px;
                box-sizing: border-box;
                transition: all 0.1s;


                .check-box {
                    position: absolute;
                    display: none;
                    top: 5px;
                    right: 5px;
                    width: 24px;
                    height: 24px;
                    z-index: 100;
                    cursor: pointer;

                    // img {
                    //     width: 100%;
                    // }
                    i {
                        font-size: 1.2em;

                        &:hover {
                            color: #f00;
                        }
                    }
                }

                .thumb {
                    cursor: pointer;
                    width: 100%;
                    height: 180px;
                    // background: $color-e7e7e7;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                }

                .product-detail {
                    transition: all 0.1s;
                    overflow: hidden;
                    position: relative;
                    background: rgba(255, 255, 255, 0.9);

                    .title {
                        cursor: pointer;
                        color: #000;
                        font-size: 14px;
                        font-weight: bold;
                        margin: 10px 0 10px;
                        line-height: 20px;
                        height: 60px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                    }

                    .subtitle {
                        font-size: 13px;
                        width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                        .subtitle-price {
                            color: #000;
                            font-size: 15px;
                            font-weight: bold;
                            margin-left: 5px;
                        }
                    }

                    .operations {
                        display: flex;
                        justify-content: space-between;
                        margin: 15px 0 0;
                        position: absolute;
                        left: 0;
                        right: 0;

                        .el-button {
                            width: 100%;
                            border-radius: 4px;
                        }

                        .el-image {
                            position: relative;
                            right: -8px;
                            width: 20px;
                            margin: 0 auto;
                        }
                    }
                }

                &:hover {
                    border-color: $color-primary;
                    box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);

                    .product-detail {
                        margin-top: -48px;
                        z-index: 1;
                        position: relative;
                        padding-bottom: 48px;
                    }
                }
            }

            .card-item-select {
                border-color: $color-primary;
                box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);

                .product-detail {
                    margin-top: -48px;
                    z-index: 1;
                    position: relative;
                    padding-bottom: 48px;

                    .operations {
                        .el-button {
                            span {
                                &::after {
                                    content: 'ed';
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .products {
        overflow-y: auto;

        .cards-wrap {
            display: flex;
            flex-wrap: wrap;
            .card-item {
                position: relative;
                width: 196px;
                min-height: 250px;
                border-radius: 4px;
                border: 1px solid #ededed;
                margin: 0 15px 40px 0;
                padding: 10px 15px 20px;
                box-sizing: border-box;
                transition: all 0.1s;


                .check-box {
                    position: absolute;
                    display: none;
                    top: 5px;
                    right: 5px;
                    width: 24px;
                    height: 24px;
                    z-index: 100;
                    cursor: pointer;

                    // img {
                    //     width: 100%;
                    // }
                    i {
                        font-size: 1.2em;
                        &:hover {
                            color: #f00;
                        }
                    }
                }

                .thumb {
                    cursor: pointer;
                    width: 100%;
                    height: 180px;
                    // background: $color-e7e7e7;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                }

                .product-detail {
                    transition: all 0.1s;
                    overflow: hidden;
                    position: relative;
                    background: rgba(255, 255, 255, 0.9);

                    .title {
                        cursor: pointer;
                        color: #000;
                        font-size: 14px;
                        font-weight: bold;
                        margin: 10px 0 10px;
                        line-height: 20px;
                        height: 60px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                    }

                    .subtitle {
                        font-size: 13px;
                        width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                        .subtitle-price {
                            color: #000;
                            font-size: 15px;
                            font-weight: bold;
                            margin-left: 5px;
                        }
                    }

                    .operations {
                        display: flex;
                        justify-content: space-between;
                        margin: 15px 0 0;
                        position: absolute;
                        left: 0;
                        right: 0;

                        .el-button {
                            width: 70%;
                            border-radius: 4px;
                        }

                        .el-image {
                            position: relative;
                            right: -8px;
                            width: 20px;
                            margin: 0 auto;
                        }
                    }
                }
                &:hover {
                    border-color: $color-primary;
                    box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);

                    .check-box {
                        display: block;
                    }
                }
            }

        }
    }

}
</style>
